import { Camera, Crosshair, Settings as Gear, TrendingUp as ChartUp } from "lucide-react";
import { EDGE_PILLARS } from "../brands";

const ICONS = [Crosshair, Camera, Gear, ChartUp];

export function Edge() {
  return (
    <section className="mt-20">
      <div className="border-t border-jw-border" />
      <div className="mx-auto max-w-6xl px-6 py-14">
        <p className="text-center font-display text-xs tracking-[0.32em] uppercase text-jw-chrome-dim mb-2">
          The Ward Systems Edge
        </p>
        <div className="jw-rule max-w-xs mx-auto mb-10" />

        <div className="grid gap-5 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
          {EDGE_PILLARS.map((p, i) => {
            const Icon = ICONS[i] ?? Crosshair;
            return (
              <div key={p.id} className="jw-pillar text-center">
                <Icon className="h-6 w-6 text-jw-steel-light mx-auto mb-3" aria-hidden />
                <h3 className="font-display text-sm font-semibold uppercase tracking-[0.14em] text-jw-chrome-bright">
                  {p.title}
                </h3>
                <p className="mt-2 text-[0.8rem] leading-relaxed text-jw-text-muted">
                  {p.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
